/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PublicationCelebration { 
    type: PublicationCelebration.TypeEnum;
    userId: number;
    fullName: string;
    /**
     * Foto de perfil actual; null si no tiene y el front pinta iniciales
     */
    photoProfileUrl?: string | null;
    departmentName?: string | null;
    jobPositionName?: string | null;
    /**
     * Años cumplidos; solo aniversarios
     */
    yearsOfService?: number | null;
    /**
     * Nacimiento, ingreso o reconocimiento según el tipo (yyyy-MM-dd)
     */
    eventDate?: string | null;
}
export namespace PublicationCelebration {
    export type TypeEnum = 'birthday' | 'anniversary' | 'admission';
    export const TypeEnum = {
        Birthday: 'birthday' as TypeEnum,
        Anniversary: 'anniversary' as TypeEnum,
        Admission: 'admission' as TypeEnum
    };
}


